import ModalDrawer, {
  ModalDrawerContent,
  ModalDrawerFooter,
  ModalDrawerHeader,
} from '@/components/basic/modal-drawer';
import Text from '@/components/basic/text';

export type MemberRequestedModalProps = {
  title: string;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

function MemberRequestedModal({
  title,
  isOpen,
  onOpenChange,
}: MemberRequestedModalProps) {
  return (
    <>
      <ModalDrawer open={isOpen} onOpenChange={onOpenChange}>
        <ModalDrawerHeader heading={`We'll be in touch soon!`} />
        <ModalDrawerContent>
          <Text variant='body1'>
            Thanks for letting us know that you would be interested in working
            with {title}! One of our colleagues will be in touch with you
            shortly to discuss your options.
          </Text>
        </ModalDrawerContent>
        <ModalDrawerFooter
          primaryActionText='Close'
          primaryAction={() => onOpenChange(false)}
        />
      </ModalDrawer>
    </>
  );
}

export default MemberRequestedModal;
